import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import { CONTACTUSPAGEVIEWS } from "common/viewContent";
import Helmet from "react-helmet";
import * as Path from "routes/Path/index";
import BackButtom from "components/BackButtom";
import { toast } from "react-toastify";
const index = () => {
  const location = useLocation();
  const [data, setData] = useState(location.state.message || {});
  console.log(location.state.message, "location.state.message");

  return (
    <>
      <Helmet title={CONTACTUSPAGEVIEWS.CURRENT_MODULE} />
      <section className="section">
        <div className="section-header">
          <BackButtom />
          <h1>{CONTACTUSPAGEVIEWS.CURRENT_MODULE}</h1>
          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.contactUs}>Contact Us</Link>
            </div>
            <div className="breadcrumb-item">
              {CONTACTUSPAGEVIEWS.CURRENT_MODULE}
            </div>
          </div>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">
                    {CONTACTUSPAGEVIEWS.TOP_CONTENT}
                  </h2>
                </div>
              </div>
            </div>
          </div>

          <div className="card p-3">
            <div className="border-bottom text-center mb-3">
              <h6 className="p-2">Contact Us Detail</h6>
            </div>

            <div className="row mb-3">
              <div className="col-md-6 ">
                <p className="mb-0">
                  <strong>Name:</strong>
                </p>
                {data?.name || "N/A"}
              </div>
              <div className="col-md-6">
                <p className="mb-0">
                  <strong>Email:</strong>
                </p>
                {data?.email || "N/A"}
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="mb-0">
                  <strong>Message: </strong>
                </div>
                {data?.message || "N/A"}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default index;
